import { Shape } from '@doordash/design-language';
import { TagSize } from './types.js';
import { shapePadding } from './constants.js';

var getTagPadding = function getTagPadding(props) {
  var shapePaddingVals = shapePadding[props.theme.Shape.TagDefault || Shape.Rectangle] || shapePadding[Shape.Rectangle];
  var paddingVals = shapePaddingVals[props.size] || shapePaddingVals[TagSize.Small];
  var verticalPadding = props.hasLeadingIcon || props.hasTrailingIcon ? paddingVals.verticalWithIcon : paddingVals.vertical;
  return "".concat(verticalPadding, "px ").concat(props.hasTrailingIcon ? paddingVals.horizontalWithIcon : paddingVals.horizontal, "px ").concat(verticalPadding, "px ").concat(props.hasLeadingIcon ? paddingVals.horizontalWithIcon : paddingVals.horizontal, "px");
};

export { getTagPadding };
